module.exports = __webpack_public_path__ + "pic/32.ccd6e03d.png";